import { render, staticRenderFns } from "./LPCardBox.vue?vue&type=template&id=64b9e164&scoped=true"
import script from "./LPCardBox.vue?vue&type=script&lang=js"
export * from "./LPCardBox.vue?vue&type=script&lang=js"
import style0 from "./LPCardBox.vue?vue&type=style&index=0&id=64b9e164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b9e164",
  null
  
)

export default component.exports